import { User } from '~/types'
import { datadogRum } from '@datadog/browser-rum'

import api from '~/api'

export const getMe = async () => {
  const { data: me } = await api.rest.get<User>('/user/me/')
  datadogRum.setUser({
    id: String(me.id),
    email: me.email,
  })
  return me
}
